import styled from 'styled-components';

export const Container = styled.div`
  width: 700px;
  padding: 30px;
  .error-img {
    img {
      max-width: 300px;
    }
  }
  .notification {
    font-size: 0.75rem;
    padding: 16px 15px;
    width: 100%;
    text-align: center;
    &.failed {
      color: #c82e29;
      background-color: #fbefee;
    }
    &.pending {
      color: #896a01;
      background-color: #faf9d1;
    }
  }
`;
